module.exports = "<p>[# summary]</p>\n<h3 id=\"asset-symbol\">Asset {symbol}</h3>\n<p>{description}</p>\n";